<template>
  <a-layout>
    <a-space>
      <a-select v-model="query['storer.id']" :placeholder="$t('business.label.storer')" allowClear class="query">
        <a-select-option v-for="d in storers" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-input v-model="query['no']" :placeholder="$t('business.label.orderNo')" allowClear class="query" @pressEnter="search"/>
      <a-input v-model="query['customer.name']" :placeholder="$t('business.label.customerName')" allowClear class="query" @pressEnter="search"/>
      <a-date-picker v-model="query.dateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('business.label.startTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.dateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('business.label.endTime')" class="query" show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="search"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="error" @click="reset"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-click="({row})=>rowClick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="=120"/>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="customer.name" title="business.label.customerName"/>
      <vxe-column :edit-render="{name:'VxeSelect',options:orderStatus}" field="order.orderStatus" title="business.label.orderStatus" width="100"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import moment from 'moment'
import { findAll, findEnum } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ModifyTable',
  data() {
    return {
      loading: false,
      data: [],
      orderStatus: [],
      storers: [],
      contentSize: 0,
      page: 1,
      size: 5,
      query: {
        'no': '',
        'customer.name': '',
        'storer.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      },
      args: null,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.225)
    }
  },
  created() {
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatus = res.result.map(item => {
          return { value: item.ordinal, label: item.name }
        })
      }
    })
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storers = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.dateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.dateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    rowClick(row) {
      this.$emit('selectRow', row.order.no)
    },
    getData() {
      this.loading = true
      this.$emit('reset')
      findAll('receiptOrderFactory', this.query, this.page, this.size).then((res) => {
        this.contentSize = res.contentSize
        this.data = res.result
      }).finally(() => this.loading = false)
    },
    search() {
      this.page = 1
      this.getData()
    },
    reset() {
      this.query = {
        'no': '',
        'customer.name': '',
        'storer.id': undefined,
        dateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        }
      }
      this.getData()
      this.$emit('reset')
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>